import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/ip-override/')({
  component: () => <Navigate to="/ip-override/user-lookup" />,
});
